var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.chosenCertificate)?_c('div',_vm._l((_vm.chosenCertificate),function(certificate){return _c('div',{key:certificate.id},[_c('certificate-details-content',{attrs:{"id":certificate.id}}),_c('hr')],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }